<template>
  <div class="menu-wrapper">
      <el-menu-item index="1" @click="index">
        <i class="el-icon-s-data"></i>
        <span slot="title">业绩统计</span>
      </el-menu-item>
      <el-menu-item index="2" @click="time">
        <i class="el-icon-success"></i>
        <span slot="title">计次会员</span>
      </el-menu-item>
      <el-menu-item index="3" @click="recharge">
        <i class="el-icon-document"></i>
        <span slot="title">打折会员</span>
      </el-menu-item>
      <el-menu-item index="4" @click="log">
        <i class="el-icon-info"></i>
        <span slot="title">记录查询</span>
      </el-menu-item>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  methods: {
    index() {
       this.$router.push('/index')
    },
    time() {
       this.$router.push('/time')
    },
    recharge() {
       this.$router.push('/recharge')
    },
    log() {
       this.$router.push('/log')
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue